import Cookies from 'js-cookie';

const TokenKey = 'beesfpd_token';
const UserInfoKey = 'beesfpd_user_info';

// Token 管理 - 使用 localStorage（與登錄頁保持一致）
export function getToken () {
  // 優先從 localStorage 讀取
  const localToken = localStorage.getItem(TokenKey);
  if (localToken) {
    return localToken;
  }
  // 兼容 Cookies
  return Cookies.get(TokenKey);
}

export function setToken (token, expires = 7) {
  // 同時保存到 localStorage 和 Cookies
  localStorage.setItem(TokenKey, token);
  return Cookies.set(TokenKey, token, { expires });
}

export function removeToken () {
  localStorage.removeItem(TokenKey);
  return Cookies.remove(TokenKey);
}

// 用戶信息管理
export function getUserInfo () {
  const userInfo = localStorage.getItem(UserInfoKey);
  try {
    return userInfo ? JSON.parse(userInfo) : null;
  } catch (e) {
    return null;
  }
}

export function setUserInfo (userInfo) {
  localStorage.setItem(UserInfoKey, JSON.stringify(userInfo));
}

export function removeUserInfo () {
  localStorage.removeItem(UserInfoKey);
}

// 清除所有認證信息
export function clearAuth () {
  removeToken();
  removeUserInfo();
}

// 檢查是否登錄
export function isLoggedIn () {
  return !!getToken();
}



// WEBPACK FOOTER //
// ./src/utils/auth.js